<script>
export default {
    name: "ViewImage",

    props: {
        image: Object,
        showModal: Boolean,
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-2/3 sm:w-11/12 h-auto">
  <template v-slot:title>
    <h5 class="font-bold text-sm">Operation Image: {{ image.comment }}</h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap items-center">
        <img :src="`data:application/image;base64,${image.investigationImage}`" >
    </div>
    <div class="w-full flex flex-wrap items-center">
        <iframe :src="`data:application/pdf;base64,${image.investigationImage}`" 
          height="800" width="1200"></iframe>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button class="btn-danger btn-sm text-xs rounded" @click="$emit('closeModal')"><i class="fa fa-times"></i> Close</button>
  </template>
</tail-modal>
</template>